<ng-template #sectionTemplate let-section let-even="even">
  <div class="cards-mobile__highlight-wrapper">
    <p
      class="{{
        even
          ? 'padding-left--xs padding-top--xs padding-bottom--xs'
          : 'cards-mobile__highlight'
      }} spacing--none"
      *ngIf="section.sectionTitle || section.sectionSubTitle"
    >
      {{ section.sectionTitle }}
      <eds-footnote
        *ngIf="section?.sectionPlacement"
        [placement]="section?.sectionPlacement"
      ></eds-footnote>
      <eds-icon
        type="info"
        size="small"
        *ngIf="section?.sectionToolTip"
        edsTooltip
        [tooltipContent]="section?.sectionToolTip"
        [analyticsName]="'products.ratings-title' | translate"
        tooltipBehavior="absolute"
        tooltipPositionDefault="bottom"
      ></eds-icon>
      <br
        *ngIf="section.sectionTitle && section.sectionSubTitle"
        class="padding-top--xs"
      />

      <small class="small">{{ section.sectionSubTitle }}</small>
    </p>
    <ng-container *ngFor="let item of section.items">
      <div
        class="{{
          even ? 'padding-left--xs padding-top--xs' : 'cards-mobile__highlight'
        }}"
        *ngIf="!item.hide"
      >
        <eds-info-item [info]="item">
          <div>
            <!-- div added to keep star icons on single line -->
            <ng-container *ngIf="item.rating">
              <eds-icon
                type="star-active"
                size="small"
                theme="ratings"
                *ngFor="let item of [].constructor(item.rating)"
              ></eds-icon>
            </ng-container>
            <ng-container *ngIf="item.hybridRating">
              <eds-icon
                type="star-inactive"
                size="small"
                theme="ratings"
                *ngFor="let item of [].constructor(item.hybridRating)"
              ></eds-icon>
            </ng-container>
            <ng-container *ngIf="item.additionalVal">
              <p class="spacing--none bold">{{ item.additionalVal }}</p>
            </ng-container>
          </div>
        </eds-info-item>
      </div>
    </ng-container>
  </div>
</ng-template>

<div class="cards-mobile">
  <eds-panel
    *ngIf="data"
    edsSpacing="sm"
    [hasBorders]="true"
    [hasBorderRadius]="false"
    [hasPadding]="false"
    [overflowHidden]="true"
  >
    <div edsPadding edsPaddingAll="md">
      <div edsFlexbox flexDirection="column" class="cards-mobile__title">
        <div edsRow [style.margin]="0">
          <button
            *ngIf="hasFavourite"
            edsColumn
            class="transparent"
            (click)="toggle()"
            edsFlexbox
            alignItems="flex-start"
          >
            <eds-icon
              class="fav-icon"
              type="bookmark-active"
              [type]="active ? 'bookmark-active' : 'bookmark-inactive'"
            >
            </eds-icon>
          </button>
          <div edsColumn [style.flex]="1">
            <a
              class="text-primary cards-mobile__title--link"
              (click)="navService.navigate($event)"
              [href]="data.fundLink"
            >
              <eds-title [level]="3" size="h5" [isLight]="true">
                {{ data.fundDetail.fundName }}
                <span *ngIf="data.fundDetail?.suffix">
                  - <strong> {{ data.fundDetail?.suffix }} </strong>
                </span>
                <span *ngIf="data.fundDetail?.secondSuffix">
                  ({{ data.fundDetail?.secondSuffix }})
                </span>
              </eds-title>
            </a>

            <!-- TODO: need final styling from EDS -->
            <ng-container *ngIf="data.showSalesCharges">
              <p class="spacing--none small">
                <small>
                  {{ "products.sales-charges" | translate }} :
                  {{ "products.max-initial-charge" | translate }}
                  - {{ data.maxIntialSalesCharge }} |
                  {{ "products.cdsc" | translate }} -
                  {{ data.cdsc }}
                </small>
              </p>
            </ng-container>
          </div>
        </div>

        <div *ngIf="data.ppssMessage">
          <ng-container *ngIf="!data.ppssTooltip">
            <eds-notifications
              edsPadding
              edsPaddingLeft="xs"
              [title]="data.ppssMessage"
              [notificationType]="notificationType"
              [inline]="true"
            ></eds-notifications>
          </ng-container>
          <ng-container *ngIf="data.ppssTooltip">
            <eds-notifications
              edsPadding
              edsPaddingLeft="xs"
              [title]="data.ppssMessage"
              [notificationType]="notificationType"
              [inline]="true"
              edsTooltip
              [analyticsName]="data.ppssMessage"
              tooltipPositionX="right"
              [tooltipContent]="data.ppssTooltip"
            ></eds-notifications>
          </ng-container>
        </div>
      </div>

      <div *ngFor="let section of fixedSections">
        <ng-container
          [ngTemplateOutlet]="sectionTemplate"
          [ngTemplateOutletContext]="{
            $implicit: section,
            even: section.isEven
          }"
        ></ng-container>
      </div>

      <eds-expand-collapse
        edsPadding
        edsPaddingbottom="sm"
        *ngIf="expandableSections.length > 0"
        [collapsedButton]="'products.more-details' | translate"
        [expandedButton]="'products.less-details' | translate"
        [top]="false"
      >
        <div *ngFor="let section of expandableSections">
          <ng-container
            [ngTemplateOutlet]="sectionTemplate"
            [ngTemplateOutletContext]="{
              $implicit: section,
              even: section.isEven
            }"
          ></ng-container>
        </div>
      </eds-expand-collapse>

      <!-- TODO: not tried download link yet -->
      <a
        *ngIf="data.downloadLabel && data.downloadLink"
        [href]="data.downloadLink"
      >
        {{ data.downloadLabel }}
        <eds-icon type="download" size="small" invert="true"></eds-icon>
      </a>
    </div>
  </eds-panel>
</div>
